module.exports = __webpack_public_path__ + "static/media/galeryCurtains3.dce00925.jpg";